// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__DXpqS","productName":"Table_productName__22OW1"};